<div class="row  justify-content-around ">

    <div class="col-12 autopartage-search-block">
      <div class="row ">
        <div class="col-12 ">
          <app-search-book-form [stations]="stationList" [mapStationSelected]="mapStationSelected" type='recharge' title="{{ 'RECHARGE.SEARCH.TITLE' | translate }}"
            (stationChanged)="stationChangedHandler($event)"></app-search-book-form>
        </div>
  
      </div>
    </div>
    <div class="col-12 margin-block">
      <app-recharge-info-block></app-recharge-info-block>
    </div>
    <div  class="col-12 margin-block">
      <app-recharge-ccm ></app-recharge-ccm>
    </div>
  </div>
  